<template>
  <div :class="['input-box', disabled ? 'disabled' : '']">
    <input
      type="text"
      v-model="inputValue"
      :readonly="disabled"
    />
    <slot name="suffix"></slot>
    <div class="token-symbol">{{ tokenSymbol }}</div>
  </div>
</template>

<script>
export default {
  name: "InputToken",
  props: {
    tokenSymbol: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  data() {
    return {
      inputValue: "",
    };
  },
  methods: {
  },
  watch: {
    value: function (newValue) {
      this.inputValue = newValue;
    },
    inputValue: function (newValue) {
      this.$emit("input", newValue);
      this.$emit('on-change', newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../common/colors.scss";
@import "../../common/fonts.scss";

.input-box {
  background: #171717;
  border-radius: 12px;
  display: flex;
  align-items: center;
  padding: 8px 16px;

  input {
    border: none;
    outline: none;
    flex: 1;
    padding: 0 16px 0 0;
    width: 100%;
    height: 100%;
    background: transparent;
    @include fontSize-14;
    @include mediumFont;
    color: #fff;
  }

  &.disabled {
    background: rgba(87, 89, 99, 0.15);
    border-radius: 12px;
    border: 1px solid rgba(151, 151, 151, 0.25);

    input {
      color: #575963;
    }
  }
}

.token-symbol {
  @include fontSize-14;
  @include regularFont;
  color: rgba(#8f92a1, 0.6);
}
</style>
